export const SUBSCRIPTION_TIERS = {
  STARTER: 'starter',
  PRO: 'pro',
  ENTERPRISE: 'enterprise'
};

// Map tiers to Paddle price IDs from environment
export const TIER_PRICE_MAP = {
  starter: process.env.REACT_APP_ARTIST_SUBSCRIPTION_STARTER_PRICE || 'pri_starter_placeholder',
  pro: process.env.REACT_APP_ARTIST_SUBSCRIPTION_PRO_PRICE || 'pri_pro_placeholder',
  enterprise: process.env.REACT_APP_ARTIST_SUBSCRIPTION_ENTERPRISE_PRICE || 'pri_enterprise_placeholder',
};

export const SUBSCRIPTION_DETAILS = {
  [SUBSCRIPTION_TIERS.STARTER]: {
    name: 'Starter',
    price: 9.99,
    currency: 'USD',
    billingCycle: 'monthly',
    description: 'Perfect for new artists',
    color: 'from-blue-500 to-blue-600',
    icon: '🎵',
    priceId: TIER_PRICE_MAP.starter,
    features: [
      { name: 'Upload Music', limit: 15, unlimited: false },
      { name: 'Upload Videos', limit: 15, unlimited: false },
      { name: 'Storage', limit: '5GB', unlimited: false },
      { name: 'Analytics', included: false },
      { name: 'Custom Profile', included: false },
    ]
  },
  [SUBSCRIPTION_TIERS.PRO]: {
    name: 'Pro',
    price: 24.99,
    currency: 'USD',
    billingCycle: 'monthly',
    description: 'For growing artists',
    color: 'from-purple-500 to-purple-600',
    icon: '🎸',
    priceId: TIER_PRICE_MAP.pro,
    features: [
      { name: 'Upload Music', limit: 50, unlimited: false },
      { name: 'Upload Videos', limit: 30, unlimited: false },
      { name: 'Storage', limit: '50GB', unlimited: false },
      { name: 'Analytics', included: true },
      { name: 'Custom Profile', included: false },
    ]
  },
  [SUBSCRIPTION_TIERS.ENTERPRISE]: {
    name: 'Enterprise',
    price: 99.99,
    currency: 'USD',
    billingCycle: 'monthly',
    description: 'For established artists',
    color: 'from-amber-500 to-amber-600',
    icon: '👑',
    priceId: TIER_PRICE_MAP.enterprise,
    features: [
      { name: 'Upload Music', limit: null, unlimited: true },
      { name: 'Upload Videos', limit: null, unlimited: true },
      { name: 'Storage', limit: null, unlimited: true },
      { name: 'Analytics', included: true },
      { name: 'Custom Profile', included: true },
    ]
  }
};

export const ARTIST_STATUS = {
  PENDING_PAYMENT: 'pending_payment',
  PENDING_APPROVAL: 'pending_approval',
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
  EXPIRED: 'expired'
};

export const CONTENT_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected'
};

export const getSubscriptionTierByPrice = (price) => {
  for (const [tier, details] of Object.entries(SUBSCRIPTION_DETAILS)) {
    if (details.price === price) {
      return tier;
    }
  }
  return null;
};

export const formatSubscriptionPrice = (tier) => {
  const details = SUBSCRIPTION_DETAILS[tier];
  return `$${details.price.toFixed(2)}/${details.billingCycle}`;
};

export const getPriceIdForTier = (tier) => {
  return SUBSCRIPTION_DETAILS[tier]?.priceId || null;
};
